import { call, put, takeLatest } from 'redux-saga/effects';
import { captureSagaError } from '../../../lib/sentry.js';
import { friendlyErrorMessage } from '../../../lib/errorCopy.js';
import * as featureVisibilityApi from '../api/featureVisibilityApi.js';
import { normalizeProficiency } from '../../progress/lib/proficiencyModel.js';
import { proficiencyLoaded } from '../../progress/store/progressSlice.js';
import {
  featureVisibilityFailed,
  featureVisibilityLoaded,
  featureVisibilityRequested,
} from './featureVisibilitySlice.js';

export function* handleFeatureVisibilityRequested() {
  try {
    const res = yield call(featureVisibilityApi.fetchFeatureVisibility);
    if (res && res.status && res.code === 200) {
      yield put(featureVisibilityLoaded(res.data));
      // Share this MyStep response with the report cache so scores and
      // detailed-report availability stay in sync with the navigation flags.
      yield put(proficiencyLoaded(normalizeProficiency(res.data)));
    } else {
      yield put(featureVisibilityFailed(res?.message || 'Failed to load feature visibility'));
    }
  } catch (err) {
    captureSagaError(err, { action: 'featureVisibility/requested' });
    yield put(featureVisibilityFailed(friendlyErrorMessage(err, 'Failed to load feature visibility')));
  }
}

export default function* featureVisibilitySaga() {
  yield takeLatest(featureVisibilityRequested.type, handleFeatureVisibilityRequested);
}
